import { Navigate, Route, Routes } from "react-router-dom";

import { AuthCallback } from "./auth/AuthCallback";
import { AuthGate } from "./auth/AuthGate";
import { SignIn } from "./auth/SignIn";
import { Layout } from "./components/Layout";
import { AccessCodes } from "./routes/AccessCodes";
import { Catalogue } from "./routes/Catalogue";
import { CatalogueDrafts } from "./routes/CatalogueDrafts";
import { CatalogueLayout } from "./routes/CatalogueLayout";
import { CostDashboard } from "./routes/CostDashboard";
import { JobDetail } from "./routes/JobDetail";
import { JobList } from "./routes/JobList";
import { ManualRun } from "./routes/ManualRun";
import { NotFound } from "./routes/NotFound";
import { PresentationReview } from "./routes/PresentationReview";
import { PresentationsDecided } from "./routes/PresentationsDecided";
import { PresentationsLayout } from "./routes/PresentationsLayout";
import { PresentationsPending } from "./routes/PresentationsPending";
import { Prompts } from "./routes/Prompts";
import { ReportIssue } from "./routes/ReportIssue";
import { ReviewBatch } from "./routes/ReviewBatch";
import { ReviewQueue } from "./routes/ReviewQueue";
import { Settings } from "./routes/Settings";

/**
 * Routing root.
 *
 * - `/sign-in` and `/auth/callback` are public.
 * - Everything else requires a Supabase session via {@link AuthGate}.
 *   Authenticated routes share the {@link Layout} (header + nav).
 */
export function App() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route element={<AuthGate />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/jobs" replace />} />
          <Route path="/jobs" element={<JobList />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/jobs/:id/review" element={<ReviewBatch />} />
          <Route path="/presentations" element={<PresentationsLayout />}>
            <Route index element={<PresentationsPending />} />
            <Route path="decided" element={<PresentationsDecided />} />
          </Route>
          <Route path="/presentations/:id/review" element={<PresentationReview />} />
          <Route path="/review" element={<ReviewQueue />} />
          <Route path="/run" element={<ManualRun />} />
          <Route path="/catalogue" element={<CatalogueLayout />}>
            <Route index element={<Catalogue />} />
            <Route path="drafts" element={<CatalogueDrafts />} />
          </Route>
          <Route path="/cost" element={<CostDashboard />} />
          <Route path="/access-codes" element={<AccessCodes />} />
          <Route path="/prompts" element={<Prompts />} />
          <Route path="/report" element={<ReportIssue />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}
